module.exports = __webpack_public_path__ + "v294910/img/save.ccbe64b0.png";